module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.54c96855.jpg";